import { render, staticRenderFns } from "./CommunicationEmailForm.vue?vue&type=template&id=4abc9939&"
import script from "./CommunicationEmailForm.vue?vue&type=script&lang=js&"
export * from "./CommunicationEmailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports